<template>
	<div id="season-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li><router-link :to="'/organization/' + $route.params.id">Organisasi</router-link></li>
      <li class="active">Organisasi Form</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{ !$route.params.id ? 'Buat' : 'Update' }} Organisasi</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">{{ !$route.params.id ? 'Buat' : 'Update' }} Organisasi</h4>
          </div>
          <div class="panel-body">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" :key="key">{{message}}</li>
              </ul>
            </div>

	          <!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
                <div class="form-group">
                  <label class="col-md-2 control-label">Nama Organisasi <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.name">
                  </div>
                </div>
                <!-- <div class="form-group">
                  <label class="col-md-2 control-label">NPSN <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <input type="email" class="form-control" v-model="data.npsn">
                  </div>
                </div> -->
                <div v-if="!$route.params.id" class="form-group">
                  <label class="col-md-2 control-label">Email Organisasi <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <input type="email" class="form-control" v-model="data.email">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Password <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <div style="margin: 10px 0px 10px 0px;">
                      <input v-model="setPass" type="checkbox" >
                      <label for="">Set Password</label>
                    </div>
                    <input :disabled="!setPass" type="password" class="form-control" v-model="data.password">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Provinsi <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <select class="form-control" v-model="data.province">
                        <option v-for="(item,index) in provinceList" v-bind:key="index">{{item}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Kota/Kabupaten <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <input type="email" class="form-control" v-model="data.city">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Alamat <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.address">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">No. Telpon <span style="color: red">*</span></label>
                  <div class="col-md-8 col-xs-12">
                    <input type="text" class="form-control" v-model="data.contact">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Gambar</label>
                  <div class="col-md-8 col-xs-12">
                    <div class="row">
                      <div class="col-md-4">
                        <!-- <img class="img-fluid" :src="'https://' + ossBucketName + '.' + ossEndpoint + '/' + data.picture" /> -->
                        <img class="img-fluid" :src="data.picture" />
                      </div>
                      <div class="col-md-8">
                        <file-upload type="assets" context="organization" v-on:uploadedData="fileUploaded"></file-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            <div class="pull-right">
              <button v-if="!$route.params.id" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
              <button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import axios from 'axios'
import Spinner from '@/components/plugins/Spinner'
import FileUpload from '@/components/plugins/FileUpload'

export default {
  name: 'season-form',
	components: {
    'app-spinner': Spinner,
    'file-upload': FileUpload,
	},
	data: function () {
	  return {
      queryId: null,
      errors: [],
      isLoading: false,
      selectedPicture: null,
      setPass: false,
      pictureurl: '',
      data: {
        name: '',
        address: '',
        contact: '',
        picture: 'assets/organization/kpw31g3x.jpg',
        email: '',
        province: '',
        city: '',
        // npsn: 0,
        password: null
      },
      provinceList: [
          "Aceh", 
          "Bali", 
          "Banten", 
          "Bengkulu", 
          "DKI Yogyakarta", 
          "DKI Jakarta", 
          "Gorontalo", 
          "Jambi", 
          "Jawa Barat", 
          "Jawa Tengah", 
          "Jawa Timur", 
          "Kalimantan Barat", 
          "Kalimantan Selatan", 
          "Kalimantan Tengah", 
          "Kalimantan Timur", 
          "Kalimantan Utara", 
          "Kepulauan Bangka Belitung", 
          "Kepulauan Riau", 
          "Lampung", 
          "Maluku", 
          "Maluku Utara", 
          "Nusa Tenggara Barat", 
          "Nusa Tenggara Timur", 
          "Papua", 
          "Papua Barat", 
          "Riau", 
          "Sulawesi Barat", 
          "Sulawesi Selatan", 
          "Sulawesi Tengah", 
          "Sulawesi Tenggara", 
          "Sulawesi Utara", 
          "Sumatera Barat", 
          "Sumatera Selatan", 
          "Sumatera Utara"
      ],
      ossEndpoint: process.env.OSS_ENDPOINT,
      ossBucketName: process.env.OSS_BUCKET_NAME
		}
	},
	mounted: function () {
    let context = this
    this.data.picture = 'https://' + context.ossBucketName + '.' + context.ossEndpoint + '/' + context.data.picture
    if (this.$route.params.id) {
      this.queryId = this.$route.params.id
      this.fetchData()
    }
	},
	methods: {
    fetchData: function () {
      var context = this
      var queryId = this.queryId
      this.isLoading = true

      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/organization/' + queryId

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      http.get(url)
        .then(function (response) {
          context.data = response.data
        })
        .catch(function (error) {
          console.log(error.message)
        })
        .then(function () {
          context.isLoading = false
        })
    },
    saveData: function () {
      var context = this
      var data = this.data
      var token = this.$ls.get('token');
      this.isLoading = true
      var url = process.env.API_BASE_URL + '/account/v2/organization'

      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      if (this.validateForm()) {
        http.post(url, data)
          .then((response) => {
            context.isLoading = false
            context.$router.push('/organizations')
          })
          .catch((error) => {
            context.isLoading = false
            alert("Gagal simpan data : " + error.response.data.message)
          })
      } else {
        this.isLoading = false
        $(window).scrollTop(0)
      }
    },
    editData: function () {
      var context = this
      var id = this.$route.params.id
      // var data = this.data
      var token = this.$ls.get('token');
      this.isLoading = true
      var url = process.env.API_BASE_URL + '/account/v2/organization/' + context.$route.params.id

      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      var data = {
          // "head_id": this.data.id,
          "name": this.data.name,
          "city": this.data.city,
          "province": this.data.province,
          "address": this.data.address,
          "contact": this.data.contact,
          "picture": this.data.picture,
          "password": this.data.password
      }
      if (this.validateForm()) {
        http.put(url, data)
          .then((response) => {
            context.isLoading = false
            alert("Update data berhasil")
            context.$router.push('/organization/' + context.$route.params.id)
          })
          .catch((error) => {
            context.isLoading = false
            alert("Gagal simpan data : " + error.response.data.message)
          })
      } else {
        this.isLoading = false
        $(window).scrollTop(0)
      }
		},
    fileUploaded: function (value) {
      let context = this
      this.data.picture = 'https://' + context.ossBucketName + '.' + context.ossEndpoint + '/' + value.key
    },
    validateForm: function () {
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      const isEmailValidate = emailRegex.test(this.data.email)

      const isNumberValidate = /^[0-9]+$/.test(this.data.contact)

      this.errors = []
      if (!this.data.name) this.errors.push('Nama wajib diisi')
      if (!this.data.email) this.errors.push('Email wajib diisi')
      // if (!this.data.npsn) this.errors.push('NPSN wajib diisi')
      if (!this.data.password && this.setPass === true) this.errors.push('Password wajib diisi')
      if (this.data.password && this.data.password.length < 6) this.errors.push('Password minimum 6 karakter')
      if (!isEmailValidate) this.errors.push('Format email salah')
      if (!this.data.address) this.errors.push('Alamat wajib diisi')
      if (!this.data.contact) this.errors.push('No. Telpon wajib diisi')
      if (!isNumberValidate) this.errors.push('Format telpon salah')
      return this.errors.length == 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrganizationForm.vue?dad479ae